import { ListingParcelData } from '~/components/'
import { Button, Dialog } from '~/components/ui'
import { Listing } from '~/models'
import { cn } from '~/utils'

export default function ParcelDataDialog({
  className,
  listing,
}: {
  className?: string
  listing: Listing
}) {
  return (
    <Dialog>
      <Dialog.Trigger asChild>
        <Button
          className={cn(className, 'text-base print:hidden', 'h-auto p-0')}
          size="sm"
          variant="link">
          View Parcel Data
        </Button>
      </Dialog.Trigger>
      <Dialog.Content className="max-w-xl">
        <Dialog.Header className="mb-2">
          <Dialog.Title>Parcel Data</Dialog.Title>
        </Dialog.Header>
        <div className="max-h-[80dvh] overflow-y-auto">
          <ListingParcelData listing={listing} />
        </div>
      </Dialog.Content>
    </Dialog>
  )
}
